import {ActionEnum} from "../action.enum";
import {UserAreaDTO} from "../../models/rights/user-area/UserAreaDTO";
import {UserAreaEditorDialog} from "../../models/rights/user-area/user-area-import-dialog.model";
import { UserAreaDetailMenuEnum } from '../../enums/rights/UserAreaDetailMenuEnum';
import {
  HorizontalClassTreeCheckboxSelectionClientService
} from '../../content/components/horizontal-class-trees/horizontal-class-tree/horizontal-class-tree-checkbox-selection/horizontal-class-tree-checkbox-selection-client.service';

export namespace UserAreaEditorActions {

  export class OpenDialog {
    static readonly type = ActionEnum.USER_AREA_EDITOR_OPEN_DIALOG;

    constructor (public mode: UserAreaEditorDialog.Mode, public userArea: UserAreaDTO) {}
  }

  export class StepForward {
    static readonly type = ActionEnum.USER_AREA_EDITOR_STEP_FORWARD;
  }

  export class StepBack {
    static readonly type = ActionEnum.USER_AREA_EDITOR_STEP_BACK;
  }

  export class CloseDialog {
    static readonly type = ActionEnum.USER_AREA_EDITOR_CLOSE_DIALOG;
  }

  export class SetSelectionType {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_SELECTION_TYPE;

    constructor (public selectionType: UserAreaEditorDialog.SelectionType) {}
  }

  export class SetOrganizationSelection {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ORGANIZATION_SELECTION;

    constructor (public selectedOrganizationIds: Set<string>) {}
  }

  export class SetLocationSelection {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_LOCATION_SELECTION;

    constructor (public selectedLocationIds: Set<string>) {}
  }

  export class SetClassSelection {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_CLASS_SELECTION;

    constructor (public selectedClassIds: Set<string>) {}
  }

  export class SetAllClassIds {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ALL_CLASS_IDS;

    constructor (public allClassIds: Set<string>) {}
  }

  export class SetObjectSelection {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_OBJECT_SELECTION;

    constructor (public selectedObjectIds: Set<string>) {}
  }

  export class SetModuleSelection {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_MODULE_SELECTION;

    constructor (public selectedModuleIds: Set<string>) {}
  }

  export class SetAllOrganizationCount {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ALL_ORGANIZATION_COUNT;

    constructor (public allOrganizationCount: number | null) {}
  }

  export class SetAllLocationCount {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ALL_LOCATION_COUNT;

    constructor (public allLocationCount: number | null) {}
  }

  export class SetAllClassCount {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ALL_CLASS_COUNT;

    constructor (public allClassCount: number | null) {}
  }

  export class SetAllObjectCount {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ALL_OBJECT_COUNT;

    constructor (public allObjectCount: number | null) {}
  }

  export class SetAllModuleCount {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SET_ALL_MODULE_COUNT;

    constructor (public allModuleCount: number | null) {}
  }

  export class Save {
    static readonly type = ActionEnum.USER_AREA_EDITOR_SAVE;

    constructor(public tabMenuEnum: UserAreaDetailMenuEnum) {}
  }
}
